import { AnyAction } from 'redux'
import * as actionType from './app.types'
import {CityType} from '../../models/CityType'

export const setCurrentCity = (value: CityType): AnyAction => ({ type: actionType.SET_CURRENT_CITY, payload: value })
export const setUserCity = (value: CityType): AnyAction => ({ type: actionType.SET_USER_CITY, payload: value })
export const resetCurrentCity = (): AnyAction => ({ type: actionType.RESET_CURRENT_CITY })
export const setScrollLock = (value: boolean): AnyAction => ({ type: actionType.SET_SCROLL_LOCK, payload: value })
export const setShowEmailConfirmModal = (value: boolean): AnyAction => ({ type: actionType.SET_SHOW_EMAIL_CONFIRM_MODAL, payload: value })
